module.exports = __webpack_public_path__ + "static/meeting2-66de2d83ca7b79640472af5df005f900.png";